import { Component } from "solid-js";
import {
  BrowseIcon,
  FoodIcon,
  GroceryIcon,
  AccessoriesIcon,
  AllBrandsIcon,
  BeautyIcon,
  ElectronicsIcon,
  EmergingBrandsIcon,
  EntertainmentIcon,
  FashionIcon,
  FitnessIcon,
  FootwearIcon,
  FurnitureIcon,
  GamingIcon,
  HandBagsIcon,
  HiddenGemsIcon,
  HomeDecorIcon,
  HotDealsIcon,
  HotelsIcon,
  InStoreBrandsIcon,
  JewelleryIcon,
  KidsIcon,
  LuxuryIcon,
  NewBrandsIcon,
  OneStopShopsIcon,
  OTTIcon,
  PharmacyIcon,
  QuickCommerceIcon,
  SoftwareIcon,
  TravelAndTransportIcon,
  WatchesIcon,
} from "@hubble/icons";

export const categoryIconMap: Record<string, Component<{ class?: string }>> = {
  BROWSE: BrowseIcon,
  FOOD: FoodIcon,
  GROCERY: GroceryIcon,
  ACCESSORIES: AccessoriesIcon,
  ALL_BRANDS: AllBrandsIcon,
  BEAUTY: BeautyIcon,
  ELECTRONICS: ElectronicsIcon,
  EMERGING_BRANDS: EmergingBrandsIcon,
  ENTERTAINMENT: EntertainmentIcon,
  FASHION: FashionIcon,
  FITNESS: FitnessIcon,
  FOOTWARE: FootwearIcon,
  FURNISHING: FurnitureIcon,
  GAMING: GamingIcon,
  HAND_BAGS: HandBagsIcon,
  HIDDEN_GEMS: HiddenGemsIcon,
  HOME_DECOR: HomeDecorIcon,
  HOT_DEALS: HotDealsIcon,
  HOTELS: HotelsIcon,
  IN_STORE_BRANDS: InStoreBrandsIcon,
  JEWELLERY: JewelleryIcon,
  KIDS: KidsIcon,
  LUXURY: LuxuryIcon,
  NEW_BRANDS: NewBrandsIcon,
  ONE_STOP_SHOPS: OneStopShopsIcon,
  OTT: OTTIcon,
  PHARMACY: PharmacyIcon,
  QUICK_COMMERCE: QuickCommerceIcon,
  SOFTWARE: SoftwareIcon,
  TRAVEL_AND_TRANSPORT: TravelAndTransportIcon,
  WATCHES: WatchesIcon,
};
